import React from 'react';

export const MovingTextAlt = () => {
  const messages = [
    'Licensed & Insured',
    'SWaM Certified',
    '20+ Years Experience',
    'Background-Checked Staff',
    'Eco-Friendly Options Available',
    '100% Satisfaction Guaranteed',
    'Residential & Commercial',
    'Serving Greater Richmond Area'
  ];

  return (
    <div className="relative bg-gradient-to-r from-[#0B7CB5] via-[#095a87] to-[#0B7CB5] py-6 overflow-hidden">
      {/* Fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0B7CB5] to-transparent z-10"></div>
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0B7CB5] to-transparent z-10"></div>
      
      <div className="moving-text-alt-container">
        <div className="moving-text-alt">
          {messages.map((message, index) => (
            <span key={index} className="inline-flex items-center mx-10 text-white text-lg font-bold whitespace-nowrap">
              <span className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"></span>
              {message}
            </span>
          ))}
          {/* Duplicate for seamless loop */}
          {messages.map((message, index) => (
            <span key={`duplicate-${index}`} className="inline-flex items-center mx-10 text-white text-lg font-bold whitespace-nowrap">
              <span className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"></span>
              {message}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
